import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_SEO_GEOENTITY } from '../../routes'
import { selectNavigateToGeoentityParameters } from '../../store/history/history.navigate.selectors'
import NavButton from '../router/NavButton'
import { generateFullRoute } from '../router/routeUtils'
import { useGoToGeoentityTagData } from './useGoToGeoentityTagData'

const GoToGeoentityButton = ({ children, poi, className, isLink = false, tagInfo = {} }) => {
  const navigateToParams = useSelector(store => selectNavigateToGeoentityParameters(store, { id: poi.id }))
  const tagData = useGoToGeoentityTagData(poi, tagInfo)

  return (
    <NavButton
      href={isLink ? generateFullRoute(ROUTE_SEO_GEOENTITY, { geoentityId: poi.id }) : ''}
      to={navigateToParams}
      tagData={tagData}
      className={className}
    >
      {children}
    </NavButton>
  )
}

export default GoToGeoentityButton
